import { render, staticRenderFns } from "./StatusTableBOM.vue?vue&type=template&id=1b88f767&"
import script from "./StatusTableBOM.vue?vue&type=script&lang=ts&"
export * from "./StatusTableBOM.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTableBOM.vue?vue&type=style&index=0&id=1b88f767&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
